"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceCustomize = void 0;
var react_1 = __importDefault(require("react"));
var Section_1 = require("../components/Section");
var variables = "$space: (\n  b: 12px, // base space\n  growth: $b2_3, // exponential-growth's base\n  n: 10, // class modifiers (from 0 to n) for spacing\n);";
var SpaceCustomize = function () { return (react_1.default.createElement(Section_1.Customize, { variables: variables })); };
exports.SpaceCustomize = SpaceCustomize;
